import { QueryHookOptions, useQuery } from 'react-apollo';
import { LIST_EVENTS_QUERY } from './list-events-query';
import { ListEventsData } from './list-events-data';
import { ListEventsVariables } from './list-events-variables';

export const useListEventsQuery = (
  variables: ListEventsVariables,
  options?: Omit<
    QueryHookOptions<ListEventsData, ListEventsVariables>,
    'variables' | 'query'
  >,
) =>
  useQuery<ListEventsData, ListEventsVariables>(LIST_EVENTS_QUERY, {
    ...options,
    variables,
  });
